import Vue from 'vue'
import fileSize from 'filesize'

Vue.filter('filesize', (val: number) => fileSize(val))
